import type { InviteUsersResult } from "@/@sdk/user-management/user-management.models";
import { toast } from "sonner";

export function showInviteUsersResultToast(result: InviteUsersResult) {
  const sentCount = result.invitations.length;
  const failedCount = result.errors.length;

  if (sentCount > 0 && failedCount === 0) {
    toast.success(
      sentCount === 1
        ? "Invitation sent"
        : `${sentCount} invitations sent`
    );
    return;
  }

  if (sentCount > 0 && failedCount > 0) {
    toast.warning(
      `${sentCount} invitation${sentCount === 1 ? "" : "s"} sent, ${failedCount} failed`
    );
    return;
  }

  if (failedCount > 0) {
    const firstError = result.errors[0];
    toast.error(firstError?.message ?? "Failed to send invitations");
  }
}
